<template>
  <div class="home">
    <h1 class="subheading grey--text">Top</h1>

    <v-container class="my-5" v-if="topTracks">
      <v-card flat v-for="tracks in topTracks.items" :key="tracks.name">
        <v-layout row wrap :class="`pa-3 project ${tracks.name}`">
          <v-flex xs12 md6>
            <div class="caption grey--text">Song</div>
            <div>{{ tracks.name }}</div>
          </v-flex>
          <v-flex xs6 sm4 md2>
            <div class="caption grey--text">Artist</div>
            <div>
              <span
                v-for="(artist, index) in tracks.artists"
                :key="artist.name"
                >{{
                  index === tracks.artists.length - 1
                    ? artist.name
                    : artist.name + ", "
                }}</span
              >
            </div>
          </v-flex>
          <!--
          <v-flex xs6 sm4 md2>
            <div class="caption grey--text">Due by</div>
            <div>{{  tracks.name }}</div>
          </v-flex>
          <v-flex xs2 sm4 md2>
            <div class="caption grey--text">Status</div>
            <div>{{  tracks.name }}</div>
          </v-flex>
          -->
        </v-layout>
        <v-divider></v-divider>
      </v-card>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bottom: false
    };
  },
  watch: {
    bottom(bottom) {
      const {
        topTracks: { next }
      } = this;

      if (bottom && next) {
        this.$store.dispatch("getTopNext", { url: next });
      }
    }
  },
  created: function() {
    this.$store.dispatch("getTop", { type: "tracks" });

    window.addEventListener("scroll", () => {
      this.bottom = this.bottomVisible();
    });
  },
  methods: {
    bottomVisible() {
      return (
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 1
      );
    }
  },
  computed: {
    topTracks() {
      return this.$store.getters.topTracks;
    }
  }
};
</script>
